import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Input, Label, Table, Row, Col, Card, CardBody } from 'reactstrap';
import PageNav from '../../components/header/page-navbar.jsx';
import { WebUrl, ApiUrl, ApiKey, PrizePlace, PrizeCategory } from '../../util/Constant';
import { useDispatch } from "react-redux";
import { showJsonResponseAlert } from "../../redux/AppAction";
import { useTranslation } from 'react-i18next';
import { AppConfiguration } from "read-appsettings-json";
import ApiEngine from '../../util/ApiEngine';
import { isObjectEmpty } from '../../util/Util.js';


/// <summary>
/// Author: -
/// </summary>
const PackagesList = props => {
    const _dispatch = useDispatch();
    const [packageList, setPackageList] = useState([]);
    const [packageTable, setPackageTable] = useState();
    var { t } = useTranslation();
    const _PRIZE_CATEGORY = {
        '4D': {
            prize: ['B', 'S', '4A', '4SB', '4SC', '4SD', '4SE', '4C'],
            place: [PrizePlace._FIRST, PrizePlace._SECOND, PrizePlace._THIRD, PrizePlace._STARTER, PrizePlace._CONSOLATION]
        },
        'Others': {
            prize: ['5D', '6D', '2D', '3D'],
            place: Object.values(PrizePlace)
        }
    }
    const _PRIZE_CATEGORY_DAILY = {
        '4D': {
            prize: ['B', 'S', '4A', '4SB', '4SC', '4SD', '4SE', '4C'],
            place: [PrizePlace._FIRST, PrizePlace._SECOND, PrizePlace._THIRD, PrizePlace._STARTER, PrizePlace._CONSOLATION]
        },
        'Others': {
            prize: ['6D', '2D', '3D'], 
            place: Object.values(PrizePlace)
        }
    };

    useEffect(() => {
        getPackageList();
    }, [])

    /// <summary>
    /// Author: -
    /// </summary>
    async function getPackageList() {
        let url = ApiUrl._API_GET_PACKAGE_LIST;

        await ApiEngine.get(url).then((responseJson) => {
            if (responseJson[ApiKey._API_SUCCESS_KEY] && responseJson[ApiKey._API_DATA_KEY]) {
                let responseData = responseJson[ApiKey._API_DATA_KEY];
                let packages = [];

                if (!isObjectEmpty(responseData['normalPackage'])) {
                    packages.push({ type: "Normal Package", ...responseData['normalPackage'] });
                }

                if (!isObjectEmpty(responseData['gdPackage'])) {
                    packages.push({ type: "GD Package", ...responseData['gdPackage'] });
                }

                if (!isObjectEmpty(responseData['nineLottoPackage'])) {
                    packages.push({ type: "9Lotto Package", ...responseData['nineLottoPackage'] });
                }

                setPackageTable(formatPackageTable(packages));
                setPackageList(packages);
            }
        });
    }

    function formatPackageTable(packageData) {
        let packageTbl = [];

        packageData.forEach((data) => {
            packageTbl[data.packageName] = {};

            Object.keys(data).filter(k => k.indexOf('PayRate') > 0 || k.indexOf('Commission') > 0)
                .forEach((key) => {
                    let newKey = key.replace('PayRate', '');

                    Object.values(PrizePlace).forEach((p) => {
                        if (newKey.indexOf(p) > 0) {
                            let category = newKey.replace(p, '');

                            if (category.startsWith('d')) {
                                category = category.substr(1);
                            }

                            if (!category.startsWith('4')) {
                                if (category.match(/^\d/)) {
                                    if (!category.startsWith("3C")) {
                                        category = category[0].toUpperCase() + "D";
                                    }
                                } else {
                                    category = category[0].toUpperCase();
                                }
                            }

                            if (!packageTbl[data.packageName].hasOwnProperty(p)) {
                                packageTbl[data.packageName][p] = [];
                            }

                            packageTbl[data.packageName][p][category] = data[key];
                        }
                    })
                });
        })

        return packageTbl;
    }

    return (
        <div id="packagesList">
            {
                packageList.find(x => x.type == "Normal Package") &&
                <>
                    {packageList
                        .filter((x) => x.type === "Normal Package")
                        .map((pkg, idx) => (
                            <div key={idx} style={{ marginBottom: "2rem" }}>
                                <h5 style={{ color: 'white'}}>
                                    {pkg.type}
                                </h5>

                                {Object.keys(_PRIZE_CATEGORY).map((catKey) => {
                                    const category = _PRIZE_CATEGORY[catKey];

                                    return (
                                        <Table
                                            bordered
                                            responsive
                                            size="sm"
                                            className="text-center align-middle custom-table"
                                            key={catKey}
                                            style={{ marginBottom: "1rem", borderRadius: "12px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>{t("PRIZE")}</th>
                                                    {category.prize.map((prize, i) => (
                                                        <th key={i} className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>
                                                            {prize}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {category.place.map((place, i) => (
                                                    <tr key={i}>
                                                        <td className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>{place}</td>
                                                        {category.prize.map((prize, j) => {
                                                            let data = packageTable[pkg.packageName][place];
                                                            let dataKey = Object.keys(data).filter(
                                                                (k) => k.indexOf(prize[0]) === 0
                                                            );

                                                            return (
                                                                <td
                                                                    key={j}
                                                                    className="table-cell"
                                                                    style={{ width: `${100 / 9}%`, whiteSpace: "nowrap", color: 'white', fontSize: 'small' }}
                                                                >
                                                                    {data.hasOwnProperty(prize) ? (
                                                                        data[prize]
                                                                    ) : dataKey.length > 0 && prize[0] === "3" ? (
                                                                        dataKey.map((k) => (
                                                                            <div key={k}>{data[k]}</div>
                                                                        ))
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    );
                                })}
                            </div>
                        ))}
                </>
            }
            {
                packageList.find(x => x.type == "GD Package") &&
                <>
                    {packageList
                        .filter((x) => x.type === "GD Package")
                        .map((pkg, idx) => (
                            <div key={idx} style={{ marginBottom: "2rem" }}>
                                <h5 style={{ color: 'white'}}>
                                    {pkg.type}
                                </h5>

                                {Object.keys(_PRIZE_CATEGORY_DAILY).map((catKey) => {
                                    const category = _PRIZE_CATEGORY_DAILY[catKey];

                                    return (
                                        <Table
                                            bordered
                                            responsive
                                            size="sm"
                                            className="text-center align-middle custom-table"
                                            key={catKey}
                                            style={{ marginBottom: "1rem", borderRadius: "12px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>{t("PRIZE")}</th>
                                                    {category.prize.map((prize, i) => (
                                                        <th key={i} className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>
                                                            {prize}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {category.place.map((place, i) => (
                                                    <tr key={i}>
                                                        <td className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>{place}</td>
                                                        {category.prize.map((prize, j) => {
                                                            let data = packageTable[pkg.packageName][place];
                                                            let dataKey = Object.keys(data).filter(
                                                                (k) => k.indexOf(prize[0]) === 0
                                                            );

                                                            return (
                                                                <td
                                                                    key={j}
                                                                    className="table-cell"
                                                                    style={{ width: `${100 / 9}%`, whiteSpace: "nowrap", color: 'white', fontSize: 'small' }}
                                                                >
                                                                    {data.hasOwnProperty(prize) ? (
                                                                        data[prize]
                                                                    ) : dataKey.length > 0 && prize[0] === "3" ? (
                                                                        dataKey.map((k) => (
                                                                            <div key={k}>{data[k]}</div>
                                                                        ))
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    );
                                })}
                            </div>
                        ))}
                </>
            }
            {
                packageList.find(x => x.type == "9Lotto Package") &&
                <>
                    {packageList
                        .filter((x) => x.type === "9Lotto Package")
                        .map((pkg, idx) => (
                            <div key={idx} style={{ marginBottom: "2rem" }}>
                                <h5 style={{ color: 'white'}}>
                                    {pkg.type}
                                </h5>

                                {Object.keys(_PRIZE_CATEGORY_DAILY).map((catKey) => {
                                    const category = _PRIZE_CATEGORY_DAILY[catKey];

                                    return (
                                        <Table
                                            bordered
                                            responsive
                                            size="sm"
                                            className="text-center align-middle custom-table"
                                            key={catKey}
                                            style={{ marginBottom: "1rem", borderRadius: "12px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>{t("PRIZE")}</th>
                                                    {category.prize.map((prize, i) => (
                                                        <th key={i} className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>
                                                            {prize}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {category.place.map((place, i) => (
                                                    <tr key={i}>
                                                        <td className="gradient-cell" style={{ width: `${100 / 9}%`, color: 'white', fontSize: 'small' }}>{place}</td>
                                                        {category.prize.map((prize, j) => {
                                                            let data = packageTable[pkg.packageName][place];
                                                            let dataKey = Object.keys(data).filter(
                                                                (k) => k.indexOf(prize[0]) === 0
                                                            );

                                                            return (
                                                                <td
                                                                    key={j}
                                                                    className="table-cell"
                                                                    style={{ width: `${100 / 9}%`, whiteSpace: "nowrap", color: 'white', fontSize: 'small' }}
                                                                >
                                                                    {data.hasOwnProperty(prize) ? (
                                                                        data[prize]
                                                                    ) : dataKey.length > 0 && prize[0] === "3" ? (
                                                                        dataKey.map((k) => (
                                                                            <div key={k}>{data[k]}</div>
                                                                        ))
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    );
                                })}
                            </div>
                        ))}
                </>
            }
        </div>
    )
}

export default PackagesList;